export const PATH_HOME = '/';
export const PATH_DASHBOARD = '/dashboard';
export const PATH_EARN = '/earn';
export const PATH_DIALOGS = '/dialogs';
export const PATH_TERMS = '/terms';
